import { useMemo } from 'react'
import { inventoryType, statusMap, typeMap, wayTypeMap } from '../config'

export default function useBillType(detail) {
  const { type, costTitleTips, wayType, status, amountTitle } = useMemo(() => {
    const item = typeMap[detail.type] || {}
    return {
      type: item.name,
      costTitleTips: item.tips || ['', ''],
      amountTitle: item.amountTitle,
      wayType: wayTypeMap[detail.wayType],
      status: statusMap[detail.status]
    }
  }, [detail])
  return {
    type,
    costTitleTips,
    amountTitle,
    wayType,
    status,
    inventoryType
  }
}
